<template>
  <section class="app-main" style="min-height: 100%;position: relative">
    <mediaTimeState></mediaTimeState>
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key"  @getShopCode='getShopCode'  :inputValue='inputValue'></router-view>
      </keep-alive>
    </transition>
    <!--<div class="upload-container">-->
      <!-- 将上传组件全局注册 -->
      <global-uploader :flieType="flieType"></global-uploader>
      <!--<div class="upload-top">aaaa</div>-->
      <!--<div class="upload-list">-->
        <!--<div class="upload-list-item">-->
          <!--<div class="upload-list-item-content">-->
            <!--<i class="file-btn-icon el-icon-run el-icon-control-listFormat"  @click="resourcesShowClick()"></i>-->
            <!--<i class="file-btn-icon el-icon-img el-icon-control-listFormat"  @click="resourcesShowClick()"></i>-->
            <!--<div class="el-text-name">Film 1.1</div>-->
            <!--<div class="el-text-size">234MB</div>-->
            <!--<div>-->
              <!--<i class="file-btn-icon el-icon-stop el-icon-control-listFormat"  @click="resourcesShowClick()"></i>-->
              <!--<i class="file-btn-icon el-icon-start el-icon-control-listFormat"  @click="resourcesShowClick()"></i>-->
              <!--<i class="file-btn-icon el-icon-del el-icon-control-listFormat"  @click="resourcesShowClick()"></i>-->
            <!--</div>-->
          <!--</div>-->

        <!--</div>-->
      <!--</div>-->

    <!--</div>-->

  </section>
</template>

<script>
import mediaTimeState from '@/components/mediaTimeState'
  import globalUploader from '@/components/VueSimpleUploader/globalUploader.vue'
export default {
  name: 'AppMain',
  data() {
    let _this = this
    return {
      demoType:false,
      inputValue:333,
      flieType:false
    }
  },
  methods:{
    getShopCode(value){
      this.flieType = value
      // //console.log(value);
    },
    ddd(d){


      this.inputValue = 55555
    }
  },
  components: {
    globalUploader,
    mediaTimeState
  },
  mounted() {
    this.ddd(1)
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.fullPath
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .upload-container{
    height: 420px;
    width: 500px;
    border-radius:10px 10px 0px 0px;
    position: fixed;
    bottom:0px;
    right: 130px;
    background: #fff;
    box-shadow: 2px 4px 6px #CCCCCC;
    .upload-top{
      width:500px;
      height:60px;
      background:linear-gradient(0deg,rgba(17,185,255,1),rgba(30,141,255,1));
      border-radius:10px 10px 0px 0px;
    }
    .upload-list{
      padding: 5px 20px;
      .upload-list-item{
        .upload-list-item-content{
          display: flex;
          align-items: center;
          height: 40px;
          .el-icon-run{
            flex: 0.1;
          }
          .el-icon-img{
            flex: 0.2;
          }
          .el-icon-stop{
            flex: 0.2;
          }
          .el-icon-start{
            flex: 0.2;
          }
          .el-icon-del{
            flex: 0.2;
          }
          .el-text-name{
            flex: 0.8;
          }
          .el-text-size{
            flex: 0.4;
          }
        }

      }
    }
  }


</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue